import React, { useState, useEffect } from 'react';
import { Row, Col, Card, OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import PayScheduleFrequency from './PayScheduleFrequency';

function EbGeneralInfo({ caseId, onError = () => { } }) {

    const fetchUrl = `${config.API_URL}/EBGeneralInformations/ByCaseId/${caseId}`;

    const [generalInfo, setGeneralInfo] = useState({});
    const [originalData, setOriginalData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchGeneralInfo();
        fetchOriginalGeneralInfo();
    }, [caseId]);

    const fetchGeneralInfo = async () => {
        try {
            const response = await axios.get(fetchUrl);
            setGeneralInfo(response.data || null);
        } catch (error) {
            setError('Error fetching plans.');
        } finally {
            setLoading(false);
        }
    };
    const fetchOriginalGeneralInfo = async () => {
        try {
            const response = await axios.get(`${config.API_URL}/EBGeneralInformations/OriginalData/ByCaseId/${caseId}`);
            const originalData = response.data || [];
            setOriginalData(originalData);
        } catch (error) {
            if (error.response?.status !== 404) {
                setError('Error fetching original case files.');
            }
            onError(error);
        }
    };

    if (loading) return <Skeleton count={10} />;
    if (error) return <div>{error}</div>;
    return (
        <Col lg={12} className="mb-3">
            <Card>
                <Card.Body>

                    <Row>
                        <Col lg={6}>
                            <Card.Title>General Information</Card.Title>
                        </Col>
                        <Col lg={6} className="text-end">
                            {/* You can add buttons or controls here if needed */}
                        </Col>
                    </Row>

                    <div className="table-responsive mb-3">
                        <table className="styled-table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th className="vertical-th"></th>
                                    <th><strong>Current Plan Year</strong></th>
                                    <th><strong>New Plan Year</strong></th>
                                </tr>
                            </thead>
                            <tbody>

                                {/* Row for Information Provider */}
                                <tr>
                                    <th>How will Clarity receive ongoing contribution data to credit participant accounts?</th>
                                    <td>{originalData?.informationProvider === "Vendor File" ? "Deposit File from Payroll Vendor" :
                                        originalData?.informationProvider === "Contribution Manager" ? "Contribution Manager" :
                                            originalData?.informationProvider === "Client File" ? "Deposit File from Client" :
                                            originalData?.informationProvider === "Prefunded HRA" ? "Does not apply we only offer prefunded HRA Plan(s)" :
                                                originalData?.informationProvider === "Autopost" ? "Autopost" : ""}</td>
                                    <td className={generalInfo?.informationProvider !== originalData?.informationProvider ? 'highlight-difference' : ''}>{generalInfo?.informationProvider === "Vendor File" ? "Deposit File from Payroll Vendor" :
                                        generalInfo?.informationProvider === "Contribution Manager" ? "Contribution Manager" :
                                            generalInfo?.informationProvider === "Client File" ? "Deposit File from Client" :
                                            generalInfo?.informationProvider === "Prefunded HRA" ? "Does not apply we only offer prefunded HRA Plan(s)" :
                                                generalInfo?.informationProvider === "Autopost" ? "Autopost" : ""}</td>
                                </tr>

                                {/* Conditional rendering for "Deposit Vendor" */}
                                {generalInfo?.informationProvider === 'Vendor File' && (
                                    <>
                                        {/* Row for Payroll Vendor Name */}
                                        <tr>
                                            <th>Payroll Vendor Name</th>
                                            <td>{originalData?.payrollProviderVendorName}</td>
                                            <td className={generalInfo?.payrollProviderVendorName !== originalData?.payrollProviderVendorName ? 'highlight-difference' : ''}>{generalInfo?.payrollProviderVendorName}</td>
                                        </tr>

                                        {/* Conditional rendering for "Other" Payroll Vendor Name */}
                                        {(generalInfo?.payrollProviderVendorName === 'Other' || originalData?.payrollProviderVendorName === 'Other') && (
                                            <tr>
                                                <th>Other Payroll Vendor Name</th>
                                                <td>{originalData?.payrollProviderOtherVendorName}</td>
                                                <td className={generalInfo?.payrollProviderOtherVendorName !== originalData?.payrollProviderOtherVendorName ? 'highlight-difference' : ''}>{generalInfo?.payrollProviderOtherVendorName}</td>
                                            </tr>
                                        )}

                                        {/* Rows for Payroll Vendor Contact Info */}
                                        <tr>
                                            <th>Payroll Vendor Contact First Name</th>
                                            <td>{originalData?.payrollProviderFirstName}</td>
                                            <td className={generalInfo?.payrollProviderFirstName !== originalData?.payrollProviderFirstName ? 'highlight-difference' : ''}>{generalInfo?.payrollProviderFirstName}</td>
                                        </tr>
                                        <tr>
                                            <th>Payroll Vendor Contact Last Name</th>
                                            <td>{originalData?.payrollProviderLastName}</td>
                                            <td className={generalInfo?.payrollProviderLastName !== originalData?.payrollProviderLastName ? 'highlight-difference' : ''}>{generalInfo?.payrollProviderLastName}</td>
                                        </tr>
                                        <tr>
                                            <th>Payroll Vendor Contact Email</th>
                                            <td>{originalData?.payrollProviderContactEmail}</td>
                                            <td className={generalInfo?.payrollProviderContactEmail !== originalData?.payrollProviderContactEmail ? 'highlight-difference' : ''}>{generalInfo?.payrollProviderContactEmail}</td>
                                        </tr>
                                    </>
                                )}

                            </tbody>
                        </table>

                    </div>

                    <Row>
                    <Col lg={6}>
                        <Card.Title>Pay Schedule Frequency</Card.Title>
                    </Col>
                    
                </Row>

                    <PayScheduleFrequency caseId={caseId}/>

                </Card.Body>
            </Card>
        </Col>
    );

}

export default EbGeneralInfo
